// NGE-1305: the room/floor the user was in when the page was reloaded.
//
// usePresenceLifecycle's beforeunload handler stashes REFRESHING / CrtRoomPid /
// CrtFloorPid in sessionStorage (only for non-home rooms). After the reload two
// consumers need them at different, unordered points of the bootstrap:
//  - WorkplaceService.initializeWorkplace restores the room (meeting, video,
//    background, presence) — once per page load
//  - usePresenceLifecycle restores the floor carousel once floorsSelected loads
// Reading the keys once and caching the result in module memory (which resets on
// every page load) means neither consumer can clear them out from under the other.

export interface ReloadRoomSnapshot {
  roomPid: string;
  floorPid: string | null;
}

let snapshot: ReloadRoomSnapshot | null | undefined;
let roomRestoreTaken = false;

/** Returns this page load's reload snapshot, or null when the page was not reloaded from a room. */
export function getReloadRoomSnapshot(): ReloadRoomSnapshot | null {
  if (snapshot !== undefined) return snapshot;

  const isRefreshing = sessionStorage.getItem('REFRESHING') === '1';
  const roomPid = sessionStorage.getItem('CrtRoomPid');
  const floorPid = sessionStorage.getItem('CrtFloorPid');

  sessionStorage.removeItem('REFRESHING');
  sessionStorage.removeItem('CrtRoomPid');
  sessionStorage.removeItem('CrtFloorPid');

  snapshot = isRefreshing && roomPid ? { roomPid, floorPid } : null;
  return snapshot;
}

/**
 * Returns the reload snapshot for room restoration exactly once per page load, so a
 * later initializeWorkplace() in the same page (e.g. an org switch) never re-restores it.
 */
export function takeReloadRoomForRestore(): ReloadRoomSnapshot | null {
  if (roomRestoreTaken) return null;
  roomRestoreTaken = true;
  return getReloadRoomSnapshot();
}
